module.exports = __webpack_public_path__ + "75d513d8c14e9600e32e497915787761.png";